/* eslint-disable react/jsx-no-bind */
/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { default as SliderWrapper } from '@mui/material/Slider';
import _isFunction from 'lodash/isFunction';
import { Box } from "../Box/index.js";
import { CurrencySymbol } from "../CurrencySymbol/index.js";
import { Typography } from "../Typography/index.js";
import { TYPOGRAPHY_VARIANT } from "../../theme/typography.theme/index.js";
import { COLOR_VARIANTS } from "../../theme/palette.theme/index.js";
import { color, isSaudiSymbol } from "../../utils/index.js";
import { ThemeSingleton } from "../../theme/index.js"; // update more state into slider component
export var Slider = function Slider(_ref) {
  var currency = _ref.currency,
    value = _ref.value,
    minAmount = _ref.minAmount,
    maxAmount = _ref.maxAmount,
    onChange = _ref.onChange,
    onChangeCommitted = _ref.onChangeCommitted,
    testId = _ref.testId,
    labelFactory = _ref.labelFactory,
    currencySymbolClass = _ref.currencySymbolClass;
  var minLabel = '';
  var maxLabel = '';
  if (Array.isArray(value)) {
    // its a range slider
    minLabel = minAmount ? value[0] : '';
    maxLabel = maxAmount ? value[1] : '';
  } else {
    // its a single slider
    minLabel = "".concat(minAmount) || '';
    maxLabel = value || '';
  }

  // eslint-disable-next-line prefer-destructuring
  var themeDirection = ThemeSingleton.getInstance('ltr').direction;
  var formatedMinLabel = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CurrencySymbol, {
    currency: currency,
    className: currencySymbolClass
  }), ' ', minLabel);
  var formatedMaxLabel = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CurrencySymbol, {
    currency: currency,
    className: currencySymbolClass
  }), ' ', maxLabel);
  return /*#__PURE__*/React.createElement(Box, {
    "data-testid": testId,
    className: "__ds__comp"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, minAmount && /*#__PURE__*/React.createElement("span", {
    style: {
      direction: isSaudiSymbol(currency || '') ? 'ltr' : themeDirection
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: TYPOGRAPHY_VARIANT.BODY2,
    color: COLOR_VARIANTS.MINESHAFT,
    component: "p",
    direction: ThemeSingleton.getInstance('ltr').isRtl ? 'rtl' : 'ltr'
  }, _isFunction(labelFactory) ? labelFactory(minLabel) : formatedMinLabel)), maxAmount && /*#__PURE__*/React.createElement("span", {
    style: {
      direction: isSaudiSymbol(currency || '') ? 'ltr' : themeDirection
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: TYPOGRAPHY_VARIANT.BODY2,
    color: COLOR_VARIANTS.MINESHAFT,
    component: "p"
  }, _isFunction(labelFactory) ? labelFactory(maxLabel) : formatedMaxLabel)))), /*#__PURE__*/React.createElement(SliderWrapper, {
    value: value,
    min: minAmount,
    max: maxAmount,
    onChange: onChange,
    onChangeCommitted: onChangeCommitted,
    defaultValue: maxAmount,
    step: 5,
    sx: {
      color: color(COLOR_VARIANTS.AQUA100),
      '& .MuiSlider-rail': {
        opacity: 1,
        backgroundColor: color(COLOR_VARIANTS.GAINSBORO)
      },
      '& .MuiSlider-thumb:hover, & .MuiSlider-thumb.Mui-focusVisible': {
        boxShadow: 'none'
      },
      '& .MuiSlider-thumb:before': {
        backgroundColor: color(COLOR_VARIANTS.AQUA100)
      },
      '& .MuiSlider-track': {
        border: 'none'
      }
    }
  })));
};